import React from "react";
import Login from "./auth/Login";
import FacebookLogin from "./auth/FacebookLogin";

export default function ConnectForm() {

  return (
    <div className="container p-5 text-center">
      {/* Bouton de connexion avec Google */}
      <Login   />
      {/* Bouton de connexion avec Facebook */}
      <FacebookLogin />

      <p className="mt-4">
        En continuant, vous acceptez nos{" "}
        <a href="/terms" className="text-primary">
          Conditions d'utilisation
        </a>{" "}
        et notre{" "}
        <a href="/privacy" className="text-primary">
          Politique de confidentialité
        </a>
        .
      </p>
    </div>
  );
}
